// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import { AutoComplete, AutoCompleteProps } from 'antd';
import React, { ReactElement } from 'react';

import './THAutoComplete.scss';

interface THAutoCompleteProps<T> extends AutoCompleteProps<T> {
    borderless?: boolean;
    filtered?: boolean;
}

export const THAutoComplete = <T,>({
    borderless = false,
    className,
    filtered,
    ...props
}: THAutoCompleteProps<T>): ReactElement => (
    <AutoComplete<T>
        className={classList('th-autocomplete', className, { 'no-border': borderless })}
        {...props}
        dropdownClassName={classList('th-autocomplete__dropdown')}
        filterOption={
            filtered
                ? (inputValue, option) => {
                      return (
                          typeof option?.value === 'string' &&
                          option?.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      );
                  }
                : props.filterOption
        }
        showArrow
        autoClearSearchValue
    />
);

THAutoComplete.Option = AutoComplete.Option;
